/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import mbpLogger from '@module-logger/mbp';
import { connect, useSelector } from 'react-redux';
import ReactHTMLParser from 'react-html-parser';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import Grid from '@material-ui/core/Grid';
import {
    object, shape, string, arrayOf, number, bool,
} from 'prop-types';
import { Link } from 'react-router-dom';
import { compose } from 'recompose';
import { getFeatureFlags } from '../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import SnipeRender from '../../GraphqlProductPage/Partials/common/SnipeRender';
import { snipePath } from '../../GraphqlProductPage/Partials/common/commonProductPageHelper';
import PriceBreakDownUi from '../../GraphqlCategoryPage/Partials/GraphqlProductContainer/Partials/GraphqlSimpleProduct/DesktopSimpleProduct/PriceBreakDownUi';
import getPriceFromEngine from '../../../../../apis/product-apis/priceEngine';
import { withAuth } from '../../../../../state/ducks/Member/ducks/Auth/Plugin/auth';
import { getEnterpriseId } from '../../../../../state/ducks/Member/ducks/EnterpriseId/EnterpriseId-Selectors';
import { getPriceArrays } from '../../../../helpers/DynamicPricing/getPriceArrays';
import PriceRange from '../../GraphqlCategoryPage/Partials/GraphqlProductContainer/Partials/GraphqlSimpleProduct/DesktopSimpleProduct/PriceRange';
import { getIsAuthenticatedStatus, getIsPassportUserLoggedIn } from '../../../../../state/ducks/Member/ducks/Common/Common-Selectors';
import { getPassportData } from '../../../../../state/ducks/Passport/Passport-Selectors';
import validatePassport from '../../../../helpers/validatePassport';
import { getPassportSubscriptionStatus } from '../../../../../state/ducks/Common/Common-Selectors';
import CaPriceVariant from '../../GraphqlCategoryPage/Partials/GraphqlProductContainer/Partials/GraphqlSimpleProduct/DesktopSimpleProduct/CaPriceTestType';

const styles = (theme) => ({
    productInfo: {
        flex: '1 1 auto',
        flexDirection: 'row',
    },
    productName: {
        textAlign: 'left',
        fontWeight: '700',
        fontSize: '16px',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        [theme.breakpoints.down('sm')]: {
            fontSize: '14px',
            fontWeight: '400',
        },
    },
    productPrice: {
        textAlign: 'left',
        fontWeight: '700',
        fontSize: '16px',
        [theme.breakpoints.down('sm')]: {
            fontSize: '14px',
        },

    },
    from: {
        fontWeight: 'normal',
    },
    imageCard: {
        width: '100%',
        marginBottom: 8,
        borderRadius: 0,
        position: ' relative',
        boxShadow: `0 2px 4px 0 ${theme.palette.imageCardBoxShadow}`,
    },
    productImage: {
        display: 'block',
        width: 'inherit',
    },
    productList: {
        padding: 8,
        '& a': {
            textDecoration: 'none',
            fontSize: '16px',
            color: theme.palette.sectionHeaderTextColor,
            [theme.breakpoints.down('sm')]: {
                fontSize: '14px',
            },
        },

    },
    crossedOutRetailPrice: {
        textDecoration: 'line-through',
        fontWeight: '400',
    },
    salePrice: {
        color: theme.palette.pdp.salePrice || '#a1001a',
    },
    passportEligibleImage: {
        width: '50% !important',
        display: 'block',
        marginBottom: '3px',
    },
    hide: {
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
    },
    snipe: {
        left: 0,
        right: 0,
        width: '100%',
        bottom: 0,
        position: 'absolute',
    },
});

const RadioOfferProductList = ({
    classes, product, flags,
}) => {
    const {
        skuPriceRange,
        isPassportEligible,
        partNumber,
    } = product;

    // Dynamic price
    const enterpriseId = useSelector(getEnterpriseId);
    const featureFlags = useSelector(getFeatureFlags);
    const [newPriceData, setNewPriceData] = useState(null);
    const isDynamicPriceEnabled = featureFlags['is-dynamic-pricing-enabled-pwa'];
    const [dynamicPriceLoading, setDynamicPriceLoading] = useState(!!isDynamicPriceEnabled);
    const isPassportUser = useSelector(getIsPassportUserLoggedIn);
    const isAuthenticated = useSelector(getIsAuthenticatedStatus);
    const passportData = useSelector(getPassportData);
    const isPassportMember = validatePassport('isActivePassportUser', passportData);
    const whichCollectionPageRestructure = featureFlags['which-collection-page-restructure'];
    const collectionRestructureVariantB = whichCollectionPageRestructure?.toLowerCase() === 'variantb';
    const [isCaDelivery, setIsCaDelivery] = useState(false);
    const isCaTransparencyPricing = featureFlags['is-ca-transparency-all-in-pricing-enabled'];

    const isPassportAdded = useSelector(getPassportSubscriptionStatus);
    let customerTypeValue = [];
    if ((isPassportMember && isPassportUser) || isPassportAdded) {
        customerTypeValue = [{
            name: 'CUSTOMER_TYPE',
            value: 'Passport',
        }];
    } else if (isAuthenticated) {
        customerTypeValue = [{
            name: 'CUSTOMER_TYPE',
            value: 'Registered',
        }];
    }

    if (!whichCollectionPageRestructure) {
        return <></>;
    }
    useEffect(() => {
        async function fetchPriceFromEngine() {
            if (!isDynamicPriceEnabled) {
                setDynamicPriceLoading(false);
                return;
            }

            if (!enterpriseId) {
                setDynamicPriceLoading(false);
                return;
            }

            const payload = {
                enterpriseId,
                products: [{
                    partNumber,
                }],
                variants: customerTypeValue,
            };

            getPriceFromEngine({}, null, payload, featureFlags['is-price-engine-batching-enabled'])
                .then(({ data }) => {
                    setDynamicPriceLoading(false);
                    setNewPriceData(data?.products);
                    setIsCaDelivery(CaPriceVariant(data, isCaTransparencyPricing));
                })
                .catch((ex) => {
                    mbpLogger.logError({
                        appName: process.env.npm_package_name,
                        jsError: ex,
                        message: `RadioOfferProductList: fetch prices failed...${ex.message}`,
                        enterpriseId,
                    });
                    setDynamicPriceLoading(false);
                });
        }

        fetchPriceFromEngine();
    }, [
        featureFlags,
        enterpriseId,
        isPassportAdded,
    ]);

    const getPrices = (priceData) => {
        const priceArrays = getPriceArrays(priceData);
        if (!priceArrays?.sale?.length && !priceArrays?.retail?.length) {
            return null;
        }
        return priceArrays;
    };

    if (product?.seo?.url) {
        return (
            <Grid item xs={12} className={classes.productList}>
                <Link
                    to={`${product.seo.url}`}
                    className={classes.product}
                >
                    <Card className={classes.imageCard}>
                        <img
                            src={`${product.image.path}${product.image.name}x.jpg`} // to do: do not hardcode the x and change based on screensize?
                            alt={product.name}
                            className={classes.productImage}
                        />
                        {product?.image?.snipe && (
                            <SnipeRender
                                styleProp={classes.snipe}
                                src={`${product?.image?.path}${product?.image.snipe}_z.gif?auto=webp`}
                                fallbackSrc={`${snipePath(product?.image?.path)}_z.gif?auto=webp`}
                            />
                        )}
                    </Card>
                    {isPassportEligible && flags && flags['is-prime-free-ship-icon-enabled'] === true && <img className={classes.passportEligibleImage} src="https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blt8d4549d3cac15860/61e09d4f2e109d6c649d4aa4/PP_EligibleIcon.svg" alt="Passport Eligible" />}
                </Link>
                <Grid container direction="column" className={classes.productInfo}>
                    <Grid item xs={12}>
                        <Link
                            to={`${product.seo.url}`}
                            className={classes.product}
                        >
                            <Typography className={classes.productName}>{ReactHTMLParser(product.name)}</Typography>
                        </Link>
                    </Grid>
                    <Grid item xs={12}>
                        <Link
                            to={`${product.seo.url}`}
                            className={classes.product}
                        >
                            {!isCaDelivery
                            && (
                                <div className={classes.productPrice}>
                                    <PriceRange
                                        skuPriceRange={isDynamicPriceEnabled && (newPriceData || []).find((item) => item.partNumber === partNumber)?.prices ? getPrices((newPriceData || []).find((item) => item.partNumber === partNumber)?.prices) : skuPriceRange}
                                        displayPrice={!dynamicPriceLoading}
                                        colorMatchTitle
                                        collectionRestructureEnabled={collectionRestructureVariantB}
                                    />
                                </div>
                            )}
                        </Link>
                        <PriceBreakDownUi
                            dynamicPriceData={(newPriceData || []).find((item) => item.partNumber === partNumber)}
                            isCaDelivery={isCaDelivery}
                            skuPriceRange={skuPriceRange}
                        />
                    </Grid>
                </Grid>
            </Grid>
        );
    }
    return null;
};
RadioOfferProductList.propTypes = {
    classes: object.isRequired,
    product: shape({
        prices: arrayOf(
            shape({
                __typename: string.isRequired,
                currency: string.isRequired,
                type: string.isRequired,
                value: number.isRequired,
            }).isRequired,
        ).isRequired,
        skuPriceRange: shape({
            sale: arrayOf(
                shape({
                    value: number.isRequired,
                }),
            ),
            retail: arrayOf(
                shape({
                    value: number.isRequired,
                }),
            ),
        }).isRequired,
        seo: shape({
            url: string.isRequired,
        }).isRequired,
        image: shape({
            name: string.isRequired,
            path: string.isRequired,
        }),
        sale: string,
        isPassportEligible: bool.isRequired,
    }).isRequired,

    flags: object.isRequired,
};

const mapStateToProps = (state) => ({
    flags: getFeatureFlags(state),
});

const enhance = compose(
    withAuth,
    withStyles(styles),
    connect(mapStateToProps),
);
export default enhance(RadioOfferProductList);
